<template>
  <div class="material-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('material_edit')" />

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.materials')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <MaterialFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import MaterialFilterForm from '../../components/material/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'MaterialList',
  servicePrefix: 'Material',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    MaterialFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.material.name'), value: 'name' },
        { text: this.$t('profile.material.state'), value: 'state.name' },
        { text: this.$t('profile.material.comment'), value: 'comment' },
        { text: this.$t('global.archive'), value: 'archive' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['archive'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('material', {
      items: 'list'
    }),
    ...mapFields('material', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('material', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
